import {
  AutocompleteInput,
  ReferenceInput,
  TextInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const cashedReturnedCheckFilterList = (permissions) => {
  const defaultFilter = [
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      variant="outlined"
      label="mine.label.start_date"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      variant="outlined"
      label="mine.label.end_date"
      minDateSource="start_date"
    />,
    <TextInput
      alwaysOn
      source="code"
      label="mine.label.receipt_no"
      resettable
      variant="outlined"
    />,
    <AutocompleteInput
      source="type"
      alwaysOn
      optionText="name"
      variant="outlined"
      label="mine.label.type"
      choices={[
        { id: 1, name: "mine.label.cashing" },
        { id: 2, name: "mine.label.cancel" },
        { id: 3, name: "mine.label.rejected" },
      ]}
    />,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};
export default cashedReturnedCheckFilterList;
